import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/main_logo_icon.svg';
import { NavLink } from 'react-router-dom';
import '../../assets/fonts/poppins_font.css';
import '../../assets/fonts/rubik_font.css';
import '../../assets/css/custom.css';
import { FaCartArrowDown } from 'react-icons/fa';
import { CgProfile } from 'react-icons/cg';
import ConfirmationModal from './Navigation/ConfirmationModal';
import UseNavigation from './Navigation/UseNavigation';
import { LuLogIn } from 'react-icons/lu';
const Header: React.FC = () => {
  const { logout, showConfirmModalLogout, showLogoutConfirmModal, setShowConfirmModalLogout, customerId } =
    UseNavigation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <header className='bg-white drop-shadow-xl'>
        <div
          className='container mx-auto flex items-center justify-between py-2.5
          sm:py-2.5 md:py-3 lg:py-3
          px-4 sm:px-4 md:px-0 lg:px-0'
        >
          {/* Logo and Brand */}
          <div className='flex flex-col items-center justify-center'>
            <Link to='/' className='hover:text-[#7C0000] transition'>
              <div className='flex flex-col items-center'>
                <img
                  src={logo}
                  alt='Namasteji Logo'
                  className='w-[7rem] h-[2rem] sm:w-[7rem] sm:h-[2rem] md:w-[8rem] md:h-[2.5rem] lg:w-[10rem] lg:h-[3.2rem] mb-0'
                />
              </div>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className='lg:hidden'>
            <button onClick={toggleMenu} className='text-[#4A2D1A] focus:outline-none'>
              <svg
                className='w-6 h-6'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'
              >
                {isMenuOpen ? (
                  <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' />
                ) : (
                  <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 6h16M4 12h16M4 18h16' />
                )}
              </svg>
            </button>
          </div>

          {/* Desktop Navigation Menu */}
          <nav className='hidden lg:flex space-x-8 text-[#4A2D1A] font-medium text-base font-poppins'>
            <NavLink
              to='/home'
              className={({ isActive }) =>
                `relative hover:text-[#7C0000] transition font-poppins ${
                  isActive
                    ? 'text-[#7C0000] after:absolute after:left-0 after:-bottom-1 after:w-full after:h-[3px] after:bg-[#7C0000]'
                    : ''
                }`
              }
            >
              HOME
            </NavLink>
            <NavLink
              to='/about'
              className={({ isActive }) =>
                `relative hover:text-[#7C0000] transition font-poppins ${
                  isActive
                    ? 'text-[#7C0000] after:absolute after:left-0 after:-bottom-1 after:w-full after:h-[3px] after:bg-[#7C0000]'
                    : ''
                }`
              }
            >
              ABOUT US
            </NavLink>

            <NavLink
              to='/products'
              state={{ scrollTo: 'target-section-pan-masala' }}
              className={({ isActive }) =>
                `relative hover:text-[#7C0000] transition ${
                  isActive
                    ? 'text-[#7C0000] after:absolute after:left-0 after:-bottom-1 after:w-full after:h-[3px] after:bg-[#7C0000]'
                    : ''
                }`
              }
            >
              OUR PRODUCT
            </NavLink>

            <NavLink
              to='/partner'
              className={({ isActive }) =>
                `relative hover:text-[#7C0000] transition ${
                  isActive
                    ? 'text-[#7C0000] after:absolute after:left-0 after:-bottom-1 after:w-full after:h-[3px] after:bg-[#7C0000]'
                    : ''
                }`
              }
            >
              BECOME PARTNER
            </NavLink>

            {/* <NavLink
              to='/reward'
              className={({ isActive }) =>
                `relative hover:text-[#7C0000] transition ${
                  isActive
                    ? 'text-[#7C0000] after:absolute after:left-0 after:-bottom-1 after:w-full after:h-[3px] after:bg-[#7C0000]'
                    : ''
                }`
              }
            >
              REWARD
            </NavLink> */}

            <NavLink
              to='/contact'
              className={({ isActive }) =>
                `relative hover:text-[#7C0000] transition ${
                  isActive
                    ? 'text-[#7C0000] after:absolute after:left-0 after:-bottom-1 after:w-full after:h-[3px] after:bg-[#7C0000]'
                    : ''
                }`
              }
            >
              CONTACT US
            </NavLink>
          </nav>

          <div className='hidden lg:block '>
            <div className='flex text-[#4A2D1A] font-medium text-base gap-4'>
              {customerId ? (
                <>
                  {/* Cart */}
                  <div className='flex flex-col items-center'>
                    <NavLink
                      to='/product/cart'
                      className={({ isActive }) =>
                        `relative hover:text-[#7C0000] transition font-poppins flex flex-col items-center ${
                          isActive
                            ? 'text-[#7C0000] after:absolute after:left-0 after:-bottom-1 after:w-full after:h-[3px] after:bg-[#7C0000]'
                            : ''
                        }`
                      }
                    >
                      <FaCartArrowDown className='-ml-1 text-xl' />
                      <span className='text-base mt-1'>Cart </span>
                    </NavLink>
                  </div>
                  <div className='flex flex-col items-center'>
                    <NavLink
                      to='/user/profile'
                      className={({ isActive }) =>
                        `relative hover:text-[#7C0000] transition font-poppins flex flex-col items-center ${
                          isActive
                            ? 'text-[#7C0000] after:absolute after:left-0 after:-bottom-1 after:w-full after:h-[3px] after:bg-[#7C0000]'
                            : ''
                        }`
                      }
                    >
                      <CgProfile className='-ml-1 text-xl' />
                      <span className='text-base mt-1'>Profile</span>
                    </NavLink>
                  </div>
                </>
              ) : (
                <>
                  <div className='flex flex-col items-center'>
                    <Link to='/login'>
                      <button className='flex justify-between items-center gap-2 px-3 py-1.5 bg-[#9b1c1c] text-white rounded-lg shadow hover:bg-[#761d1d] transition-colors'>
                        <LuLogIn className='w-5 h-5' />
                        <span className='text-sm font-medium font-poppins'>Sign In</span>
                      </button>
                    </Link>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className='lg:hidden bg-white py-4 px-4 border-t font-poppins'>
            <nav className='flex flex-col space-y-3 text-[#4A2D1A] font-medium'>
              <Link
                to='/home'
                className='hover:text-[#7C0000] transition font-poppins'
                onClick={() => setIsMenuOpen(false)}
              >
                HOME
              </Link>
              <Link
                to='/about'
                className='hover:text-[#7C0000] transition font-poppins'
                onClick={() => setIsMenuOpen(false)}
              >
                ABOUT US
              </Link>
              <Link
                to='/products'
                state={{ scrollTo: 'target-section-pan-masala' }}
                className='hover:text-[#7C0000] transition'
                onClick={() => setIsMenuOpen(false)}
              >
                OUR PRODUCT
              </Link>
              <Link
                to='/partner'
                state={{ scrollTo: 'target-section-pan-masala' }}
                className='hover:text-[#7C0000] transition'
                onClick={() => setIsMenuOpen(false)}
              >
                BECOME PARTNER
              </Link>

              {/* <Link
                to='/reward'
                state={{ scrollTo: 'target-section-pan-masala' }}
                className='hover:text-[#7C0000] transition'
                onClick={() => setIsMenuOpen(false)}
              >
                REWARD
              </Link> */}
              {customerId ? (
                <>
                  <Link
                    to='/product/cart'
                    state={{ scrollTo: 'target-section-pan-masala' }}
                    className='hover:text-[#7C0000] transition'
                    onClick={() => setIsMenuOpen(false)}
                  >
                    CART
                  </Link>
                  <Link
                    to='/orders/history'
                    state={{ scrollTo: 'target-section-pan-masala' }}
                    className='hover:text-[#7C0000] transition'
                    onClick={() => setIsMenuOpen(false)}
                  >
                    ORDERS-HISTORY
                  </Link>
                  <Link
                    to='/user/address'
                    className='hover:text-[#7C0000] transition'
                    onClick={() => setIsMenuOpen(false)}
                  >
                    ADDRESS
                  </Link>
                  <Link
                    to='/user/profile'
                    className='hover:text-[#7C0000] transition'
                    onClick={() => setIsMenuOpen(false)}
                  >
                    PROFILE
                  </Link>
                  <button
                    className='hover:text-[#7C0000] transition text-left'
                    onClick={() => {
                      setIsMenuOpen(false);
                      showLogoutConfirmModal();
                    }}
                  >
                    SIGN OUT
                  </button>
                </>
              ) : (
                <Link to='/login' className='hover:text-[#7C0000] transition' onClick={() => setIsMenuOpen(false)}>
                  SIGN IN
                </Link>
              )}

              <Link to='/contact' className='hover:text-[#7C0000] transition' onClick={() => setIsMenuOpen(false)}>
                CONTACT US
              </Link>
            </nav>
          </div>
        )}
      </header>
      {showConfirmModalLogout && (
        <ConfirmationModal logout={logout} setShowConfirmModalLogout={setShowConfirmModalLogout} />
      )}
    </>
  );
};

export default Header;
